import { combineReducers } from 'redux';
import { firestoreReducer } from 'redux-firestore';
import userReducer from './userReducer';
import documentReducer from './documentReducer';
import authReducer from './authReducer';
import leadScoreReducers from './leadScoreReducers';
import docUploadProgressReducer from './docUploadProgress';
import examReducer from './examReducer';
import onboardingReducer from './onboardingReducer';
import podcastReducer from './podcastReducer';
import infographicReducer from './infographicReducer';
import appReducer from './appReducer';
import remoteConfigReducer from './remoteConfigReducer';
import tutorialReducer from './tutorialReducer';
import gamificationReducer from './gamificationReducer';
import maturitaReducer from './maturitaReducer';

export default combineReducers({
  auth: authReducer,
  user: userReducer,
  document: documentReducer,
  firestore: firestoreReducer,
  docUploadProgress: docUploadProgressReducer,
  leadScore: leadScoreReducers,
  exam: examReducer,
  onboarding: onboardingReducer,
  podcast: podcastReducer,
  infographic: infographicReducer,
  app: appReducer,
  remoteConfig: remoteConfigReducer,
  tutorial: tutorialReducer,
  gamification: gamificationReducer,
  maturita: maturitaReducer,
});
